<script setup lang="ts"></script>

<template>
  <BaseTextButton color="danger" v-tooltip="'Delete'">
    <BaseIconDelete />
  </BaseTextButton>
</template>

<style scoped></style>
